export const CAC_DEFAULT_OPTIONS = {
	endpoint: window.mivaJS.urls.api,
	fnKeyword: 'get'
};

export class CustomApiController {
	constructor (host, options = CAC_DEFAULT_OPTIONS) {
		// Add controller to host
		(this.host = host).addController(this);

		// Set params
		this.endpoint = options.endpoint ?? CAC_DEFAULT_OPTIONS.endpoint;
		this.fnKeyword = options.fnKeyword ?? CAC_DEFAULT_OPTIONS.fnKeyword;
	}

	async send (fn, params) {
		const url = new URL(this.endpoint);

		// Set the "function" keyword
		url.searchParams.set(this.fnKeyword, fn);

		// Set additional params to url
		for (let key in params) {
			url.searchParams.append(key, params[key]);
		}

		const response = await fetch(url, {
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'get'
		});

		if (!response.ok) {
			return void 0;
		}

		const json = await response.json();

		return json;
	}
};
